module.exports = __webpack_public_path__ + "img/logo_6.b2f89e67.jpg";